import React from 'react';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../components/SingleControlCustom/getRenderControl';
import DatePickerCustom, {
  enumTypePicker,
} from '../../../../components/DatePickerCustom';
import { dateRangeEnum } from '../../../../constants/dateRangeEnum';
import { useDispatch, useSelector } from 'react-redux';
import {
  applyDateRange,
  applyDateRangeField,
} from '../../../../store/actions/documentFilterNew.actions';

const optionChoice = [
  {
    name: 'Создание',
    id: dateRangeEnum.CREATE,
    value: dateRangeEnum.CREATE,
    key: dateRangeEnum.CREATE,
    content: 'Создание',
    search: 'Создание',
  },
  {
    name: 'Регистрация',
    id: dateRangeEnum.REGISTER,
    value: dateRangeEnum.REGISTER,
    key: dateRangeEnum.REGISTER,
    content: 'Регистрация',
    search: 'Регистрация',
  },
  {
    name: 'Выполнение',
    id: dateRangeEnum.EXECUTION,
    value: dateRangeEnum.EXECUTION,
    key: dateRangeEnum.EXECUTION,
    content: 'Выполнение',
    search: 'Выполнение',
  },
];

const PeriodSelection = () => {
  const { dateRangeField, dateRange } = useSelector(
    (state) => state.documentFilterNewStore
  );

  const dispatch = useDispatch();

  const handleChangeDateRangeField = (value) => {
    dispatch(applyDateRangeField(value));
  };

  const handleChangeDateRange = (value) => {
    dispatch(applyDateRange(value));
  };

  return (
    <div>
      <Form.Item
        label="Выбор"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={dateRangeField}
          onChange={(value) => handleChangeDateRangeField(value)}
          multiple={false}
          options={optionChoice}
          renderControl={getRenderControl({
            options: optionChoice,
            isClear: false,
            onClearClick: () => {
              handleChangeDateRangeField(null);
            },
            value: dateRangeField,
            placeholder: 'Выбор',
          })}
        />
      </Form.Item>

      <Form.Item
        label="Дата"
        style={{ margin: 0 }}
      >
        <DatePickerCustom
          value={dateRange}
          onChange={(value) => handleChangeDateRange(value)}
          typePicker={enumTypePicker.RANGE}
          size="large"
          placeholder={['ДД.ММ.ГГГГ', 'ДД.ММ.ГГГГ']}
          style={{ width: '100%' }}
        />
      </Form.Item>
    </div>
  );
};

export default PeriodSelection;
